import { render, staticRenderFns } from "./AppTerms.vue?vue&type=template&id=4bc7d646&scoped=true&"
import script from "./AppTerms.vue?vue&type=script&lang=ts&"
export * from "./AppTerms.vue?vue&type=script&lang=ts&"
import style0 from "./AppTerms.vue?vue&type=style&index=0&id=4bc7d646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc7d646",
  null
  
)

export default component.exports